import { Modal } from "react-bootstrap";
import SuperSearchList from "../SuperSearch/SuperSearchList";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModalFooter from "../../Setup/Shared/ModalFooter";
import { useSelector } from "react-redux";
import isNull from "../../../utils/NullChecking";
import { useEffect, useState } from "react";
import FormValidator from "../../../utils/FormValidator";
import { enumUtil } from "../../../utils/Enum";
import States, { AdmissionStatusDropDown, Gender } from "../../../utils/Constants";
import handleNumericCheck from "../../../utils/HandleNumericKeys";
import { ServerRequestClearnigHouse, ServerRequestProtected } from "../../../utils/ServerDataRequest";
import { format } from "date-fns";
import handleAlphabeticCheck from "../../../utils/HandleAlphabetKeys";
import DatePicker from "../../General/DatePicker";
import NotificationHandler from "../../../utils/NotificationHandler";
import { FindFirstChild } from "../../../utils/FindMenuOption";
import DropdownValueHandler from "../SuperSearch/DropdownValueHandler";
import Loader from "../Loader/Loader";
const AddNewPat = (props) => {
    const { isOpenPatient, onClose, ID, MedicaidNo } = { ...props }
    let IsEditAllowed = FindFirstChild('Patient', 'Demographics')?.IsAdd
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let IsHomeCare = useSelector(state => state.GeneralDropDownsReducer.IsHomeCare);
    let Patient_Modal = {
        ProfilePicture: "",
        AccountNumber: '',
        LastName: '',
        FirstName: '',
        Gender: '',
        DOB: null,
        Address: '',
        City: '',
        State: '',
        ZipCode: '',
        HomePhoneNumber: '',
        MobileNumber: '',
        Email: '',
        LocationID: '',
        ProviderID: '',
        RefProviderID: '',
        Statuss: true,
        MedicaidNo: '',
        AdmissionStatus: "",
        Date: "",
        Notes: "",
        Source: "",
        SubscriberID: "",
        InsuranceID: "",
    }
    let valModal = {}
    let ValidationModal = {
        FirstNameVal: "",
        LastNameVal: "",
        ZipCodeLengthVal: "",
        HomePhoneNumberlen: "",
        MobileNumberlen: "",
        EmailAddressVal: "",
        ZipCodeVal: "",
        LocationIdVal: "",
        ProviderIdVal: "",
    }
    const [mainPatientModal, setmainPatientModal] = useState(Patient_Modal);
    const [PatientSaveUpdateModal, setPatientSaveUpdateModal] = useState({})
    const [PatientValidationModal, setPatientValidationModal] = useState(ValidationModal)
    const [is, setIs] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const API_URL = enumUtil.controller.PATIENT
    const API_URL_CH = enumUtil.controller.EDI
    const API_URL_GENERAL = enumUtil.controller.General
    const [insuranceBody, setinsuranceBody] = useState({
        "TableName": enumUtil.enumAPITableName.Insurance,
        "SearchParam": '',
    });
    useEffect(() => {
        setIs(true)
        if (!isNull(ID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL_GENERAL + "/FindPatientDetails", 'post', {
                'TableName': enumUtil.enumAPITableName.VISITS,
                'ID': ID,
                'SearchCriteria': {
                    MedicAidNo: MedicaidNo
                }
            }).then((response) => {
                const stateID = response.State;
                const genderID = response.Gender;
                response.State = DropdownValueHandler(States, response.State)

                response.State = DropdownValueHandler(States, response.State);
                response.Gender = DropdownValueHandler(DropDowns.Gender, response.Gender);

                response.Statuss = 'true'
                setmainPatientModal(response)
                setPatientSaveUpdateModal({
                    ...response,
                    State: stateID,
                    Gender: genderID
                })
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setPatientSaveUpdateModal({ ...PatientSaveUpdateModal, Statuss: 'true' })
            })
        }

    }, [])
    const PatientValidation = async () => {
        let HomeNmber = "";
        let MobileContact = "";
        if (!isNull(mainPatientModal.HomePhoneNumber)) {
            HomeNmber = mainPatientModal.HomePhoneNumber.replace(/[()-\s]/g, '');
        }
        if (!isNull(mainPatientModal.MobileNumber)) {
            MobileContact = mainPatientModal.MobileNumber.replace(/[()-\s]/g, '');
        }
        let ValidationModal = {
            FirstNameVal: FormValidator(
                mainPatientModal.FirstName,
                enumUtil.enumValidationType.Required,
                'First Name',
            ),
            LastNameVal: FormValidator(
                mainPatientModal.LastName,
                enumUtil.enumValidationType.Required,
                'Last Name',
            ),
            GenderVal: FormValidator(
                mainPatientModal.Gender,
                enumUtil.enumValidationType.Required,
                'Gender',
            ),
            DOBVal: FormValidator(
                mainPatientModal.DOB,
                enumUtil.enumValidationType.Required,
                'DOB',
            ),
            ZipCodeLengthVal: FormValidator(
                mainPatientModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            HomePhoneNumberlen: FormValidator(
                HomeNmber,
                enumUtil.enumValidationType.Length,
                'Home Number',
                10
            ),
            MobileNumberlen: FormValidator(
                MobileContact,
                enumUtil.enumValidationType.Length,
                'Mobile Number',
                10
            ),
            EmailAddressVal: FormValidator(
                mainPatientModal.Email,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
            ZipCodeVal: FormValidator(
                mainPatientModal.ZipCode,
                enumUtil.enumValidationType.Digit,
                'Zip Code'
            ),
            LocationIdVal: FormValidator(
                mainPatientModal.LocationID,
                enumUtil.enumValidationType.Required,
                'Location'
            ),
            ...(IsHomeCare !== 'true' && {
                ProviderIdVal: FormValidator(
                    mainPatientModal.ProviderID,
                    enumUtil.enumValidationType.Required,
                    'Provider'
                ),
            })
        }
        await setPatientValidationModal(ValidationModal)
        valModal = ValidationModal

    }
    const handlePatientChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainPatientModal };
        let saveModal = { ...PatientSaveUpdateModal }
        const dropdownFields = ['Gender', 'State', 'LocationID', 'ProviderID', 'RefProviderID', 'InsuranceID'];
        if (name === 'Statuss') {
            modal[name] = !modal[name]
        } else if (name === 'MobileNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        } else if (name === 'HomePhoneNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        } else {
            modal[name] = value
        }
        setmainPatientModal(modal)
        for (var property in Patient_Modal) {
            if (name === property && !dropdownFields.includes(name)) {
                if (name === 'Statuss') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setPatientSaveUpdateModal(saveModal)
    }

    const handleChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainPatientModal };
        modal[name] = value
        setmainPatientModal(modal)
        if (name === 'InsuranceID') {
            setinsuranceBody({ "TableName": enumUtil.enumAPITableName.Insurance, "SearchParam": value })
        }

    }
    const handleGenderCheck = (e) => {
        let value = e.target.value
        ServerRequestClearnigHouse(API_URL_CH + "/CheckGender", 'post', {
            "Value": value,
            "TableName": enumUtil.enumAPITableName.PatientDMGData
        }).then((response) => {
            mainPatientModal.Gender = response.result
            setIsLoading(false)
        }).catch((error) => {
            // NotificationHandler(error.message, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainPatientModal };
        let saveModal = { ...PatientSaveUpdateModal }
        modal[type] = FormatedDate
        setmainPatientModal(modal)
        for (var property in Patient_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setPatientSaveUpdateModal(saveModal)
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainPatientModal };
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            PatientSaveUpdateModal[name] = selectedData.value + "";
        } else if (type === 'server' && !isNull(selectedData)) {
            console.log(selectedData);
            modal[name] = selectedData.display
            PatientSaveUpdateModal[name] = selectedData.value + "";
        } else {

            modal[name] = ''
            PatientSaveUpdateModal[name] = ''
        }
        setmainPatientModal(modal)

        return selectedData
    }
    const handleSavePatient = async () => {
        await PatientValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            if (!isNull(PatientSaveUpdateModal.MobileNumber)) {
                PatientSaveUpdateModal['MobileNumber'] = PatientSaveUpdateModal.MobileNumber.replace(/[()-\s]/g, "");
            }
            if (!isNull(PatientSaveUpdateModal.HomePhoneNumber)) {
                PatientSaveUpdateModal['HomePhoneNumber'] = PatientSaveUpdateModal.HomePhoneNumber.replace(/[()-\s]/g, "");
            }
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Patient,
                ID: '0',
                data: { ...PatientSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SavePatientAndInsurance", 'post', saveModal).then((response) => {
                // if (!isNull(response.id)) {
                setIsLoading(false)
                onClose()
                NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                // }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const handleCalendarChangeadmission = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainPatientModal };
        let saveModal = { ...PatientSaveUpdateModal }
        modal[type] = FormatedDate
        setmainPatientModal(modal)
        for (var property in Patient_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setPatientSaveUpdateModal(saveModal)
    }

    const getInitials = (firstName, lastName) => {
        const firstInitial = firstName ? firstName[0].toUpperCase() : '';
        const lastInitial = lastName ? lastName[0].toUpperCase() : '';
        return firstInitial + lastInitial;
    };

    const userInitials = getInitials(mainPatientModal?.FirstName, mainPatientModal?.LastName);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setmainPatientModal({ ...mainPatientModal, Picture: reader.result });
            setPatientSaveUpdateModal({ ...PatientSaveUpdateModal, Picture: reader.result });
        };
        reader.readAsDataURL(file);
    };

    return (
        <Modal show={isOpenPatient} onHide={isOpenPatient} backdrop="static" keyboard={false} centered dialogClassName="app-modal ar_add-pateint hk-modal-v1">
            {isLoading ? <Loader /> : null}
            <div className='ar-header'>
                <div className="d-flex justify-content-between align-items-center">
                    <p className='heading fs-14 dark-clr'>{mainPatientModal.FirstName ? mainPatientModal.FirstName : 'Add New Patient'}</p>
                    <div>
                        <i className="icon-x-cros fs-20 dark-clr cursor-pointer" onClick={onClose}></i>
                    </div>
                </div>
            </div>
            <div className='row ar-content'>
                <div className='col-md-3 mt-2 hk-sidebar-v1'>
                    <div className="img-container s-90 circle">
                        {mainPatientModal?.Picture ? (
                            <div className="img-container s-90 circle border-2 border-white">
                                <img src={mainPatientModal.Picture} alt="user profile" />
                            </div>
                        ) : mainPatientModal?.FirstName ? (
                            mainPatientModal?.Gender === "Male" ?
                                <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-36 text-white za-male">
                                    {userInitials}
                                </p>

                                :
                                mainPatientModal?.Gender === "Female" ?
                                    <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-36 text-white za-female">
                                        {userInitials}
                                    </p>
                                    :
                                    <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-36 text-white  za-others">
                                        {userInitials}
                                    </p>
                        ) : (

                            <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-36 text-white za-no-gender">
                                {/* {userInitials} */}
                            </p>
                        )}
                        {mainPatientModal?.Picture ? <></> : <i className="icon-camera-outline fs-24" />}

                        <input type="file" name="Picture" id="Picture" className='cursor-pointer'
                            onChange={handleImageChange} />
                    </div>
                    <div className="row position-relative">
                        <div className='input flex-grow-1 mt-2 px-0'>
                            <label className='mb-1' >Account #</label>
                            <input
                                type="text"
                                className='form-control'
                                name="AccountNumber"
                                id="AccountNumber"
                                value={mainPatientModal.AccountNumber}
                                onChange={handlePatientChange}
                                onKeyPress={(event) => handleNumericCheck(event)}
                            />
                        </div>
                        <div class="form-check form-switch radio_button hk-active__btn">
                            <label class="form-check-label" for="mySwitch">Active</label>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                id="mySwitch"
                                name="Statuss"
                                checked={mainPatientModal.Statuss}
                                onChange={handlePatientChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input px-0 mt-2">
                            <label className='mb-1'>First Name <span className='req'>*</span></label>
                            <div className={PatientValidationModal.FirstNameVal ? 'input error' : 'input'}>
                                <input type="text"
                                    className='form-control'
                                    name="FirstName"
                                    id="FirstName"
                                    maxLength={35}
                                    onKeyPress={handleAlphabeticCheck}
                                    value={mainPatientModal.FirstName}
                                    onChange={handlePatientChange}
                                    onBlur={handleGenderCheck}
                                />
                                {PatientValidationModal.FirstNameVal}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className='input px-0 mt-2'>
                            <label className='mb-1'>Last Name<span className='req'>*</span></label>
                            <div className={PatientValidationModal.LastNameVal ? 'input error' : 'input'}>
                                <input type="text"
                                    className='form-control '
                                    name="LastName"
                                    id="LastName"
                                    maxLength={35}
                                    onKeyPress={handleAlphabeticCheck}
                                    value={mainPatientModal.LastName}
                                    onChange={handlePatientChange}
                                />
                                {PatientValidationModal.LastNameVal}

                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className='input px-0 mt-2'>
                            <label className='mb-1'>DOB <span className='req'>*</span></label>
                            <div className={PatientValidationModal.DOBVal ? 'input error' : 'input'}>
                                <DatePicker
                                    id="dobInput"
                                    value={mainPatientModal.DOB}
                                    handleCalendarChangefunc={date => handleCalendarChange(date, 'DOB')}
                                    showLabel={false}
                                />
                                {PatientValidationModal.DOBVal}
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className='input px-0 mt-2'>
                            <label className='mb-1'>Gender  <span className='req'>*</span></label>
                            <div className={PatientValidationModal.GenderVal ? 'input error' : 'input'}>
                                <SuperSearchList
                                    type="client"
                                    id='Gender'
                                    name='Gender'
                                    searchValue={mainPatientModal.Gender}
                                    data={Gender}
                                    onChange={handlePatientChange}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    inputError={PatientValidationModal.GenderVal}
                                />
                                {PatientValidationModal.GenderVal}
                            </div>


                        </div>
                    </div>
                </div>
                <div className='col-md-9 pe-0'>
                    <div className="app-accordian">
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                className='px-2'
                                expandIcon={<ExpandMoreIcon />}
                                id="Pateint1-header"
                                aria-controls="Pateint1-content"
                            >
                                <p className="heading">Address Information</p>
                            </AccordionSummary>
                            <AccordionDetails className='px-0 py-1'>
                                <div className='row px-3'>
                                    <div className='input flex-grow-1  px-0'>
                                        <label className='mb-1' >Address</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            name="Address"
                                            id="Address"
                                            value={mainPatientModal.Address}
                                            onChange={handlePatientChange}
                                        />
                                    </div>
                                </div>
                                <div className='d-flex gap-10 ps-1 pe-4 mt-2'>
                                    <div className='input flex-grow-1 col-md-4'>
                                        <label className='mb-1' >City</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            name="City"
                                            id="City"
                                            maxLength={30}
                                            value={mainPatientModal.City}
                                            onChange={handlePatientChange}
                                        />
                                    </div>
                                    <div className='input flex-grow-1 col-md-4'>
                                        <label className='mb-1'>State</label>
                                        <SuperSearchList
                                            type="client"
                                            id='State'
                                            name='State'
                                            searchValue={mainPatientModal.State}
                                            data={States}
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                    <div className='input flex-grow-1 col-md-4'>
                                        <label className='mb-1' >Zip Code</label>
                                        <div className={PatientValidationModal.ZipCodeVal || PatientValidationModal.ZipCodeLengthVal ? 'input error' : 'input'}>
                                            <input
                                                type="text"
                                                className='form-control'
                                                id="ZipCode"
                                                name="ZipCode"
                                                maxLength={9}
                                                value={mainPatientModal.ZipCode}
                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                onChange={handlePatientChange}
                                            />
                                            {PatientValidationModal.ZipCodeVal || PatientValidationModal.ZipCodeLengthVal}
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                    <div className="app-accordian mt-2">
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                className='px-2'
                                expandIcon={<ExpandMoreIcon />}
                                id="Pateint1-header"
                                aria-controls="Pateint1-content"
                            >
                                <p className="heading">Contact Information</p>
                            </AccordionSummary>
                            <AccordionDetails className='px-0 py-1'>
                                <div className='d-flex gap-10 ps-1 pe-4'>
                                    <div className='input flex-grow-1 col-md-4'>
                                        <label className='mb-1' >Cell #</label>
                                        <div className={PatientValidationModal.MobileNumberlen ? 'input error' : 'input'}>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="MobileNumber"
                                                id="MobileNumber"
                                                placeholder="(555) 555-5555"
                                                value={mainPatientModal.MobileNumber}
                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                onChange={handlePatientChange}
                                            />
                                            {PatientValidationModal.MobileNumberlen}
                                        </div>
                                    </div>
                                    <div className='input flex-grow-1 col-md-4'>
                                        <label className='mb-1' >Phone Number</label>
                                        <div className={PatientValidationModal.HomePhoneNumberlen ? 'input error' : 'input'}>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="HomePhoneNumber"
                                                id="HomePhoneNumber"
                                                placeholder="555-555-5555"
                                                value={mainPatientModal.HomePhoneNumber}
                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                onChange={handlePatientChange}
                                            />
                                            {PatientValidationModal.HomePhoneNumberlen}

                                        </div>
                                    </div>
                                    <div className='input flex-grow-1 col-md-4'>
                                        <label className='mb-1' >Email</label>
                                        <div className={PatientValidationModal.EmailAddressVal ? 'input error' : 'input'}>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="Email"
                                                id="Email"
                                                maxLength={50}
                                                value={mainPatientModal.Email}
                                                onChange={handlePatientChange}
                                            />
                                            {PatientValidationModal.EmailAddressVal}
                                        </div>

                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>

                    <div className="app-accordian mt-2">
                        {IsHomeCare === 'true' ?
                            <>
                                <Accordion defaultExpanded={false}>
                                    <AccordionSummary
                                        className='px-2'
                                        expandIcon={<ExpandMoreIcon />}
                                        id="Pateint1-header"
                                        aria-controls="Pateint1-content"
                                    >
                                        <p className="heading">Assigned Profiles</p>
                                    </AccordionSummary>
                                    <AccordionDetails className='px-0 py-1'>
                                        <div className='d-flex gap-10 ps-1 pe-4'>
                                            <div className={PatientValidationModal.LocationIdVal ? 'input flex-grow-1 col-md-4 error' : 'input flex-grow-1 col-md-4'}>
                                                <label className='mb-1' >Location  <span className='req'>*</span></label>
                                                <SuperSearchList
                                                    type="client"
                                                    id='LocationID'
                                                    name='LocationID'
                                                    searchValue={mainPatientModal.LocationID}
                                                    data={DropDowns.Location}
                                                    onChange={handleChangeDD}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                />
                                                {PatientValidationModal.LocationIdVal}
                                            </div>
                                            <div className='input flex-grow-1 col-md-4'>
                                                <label className='mb-1' >Medicaid #</label>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    name="MedicaidNo"
                                                    id="MedicaidNo"
                                                    value={mainPatientModal.MedicaidNo}
                                                    onChange={handlePatientChange}
                                                />
                                            </div>

                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion defaultExpanded={false}>
                                    <AccordionSummary
                                        className='px-2'
                                        expandIcon={<ExpandMoreIcon />}
                                        id="Pateint2-header"
                                        aria-controls="Pateint2-content"
                                    >
                                        <p className="heading">Admission</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-half'>
                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label>Status</label>
                                                    <select
                                                        className='form-control'
                                                        id='AdmissionStatus'
                                                        name='AdmissionStatus'
                                                        value={mainPatientModal.AdmissionStatus}
                                                        onChange={handlePatientChange}
                                                    >
                                                        {/* <option>{CoveragePriority.display}</option> */}
                                                        {AdmissionStatusDropDown.map((e, index) => (
                                                            <option value={e.value} key={index}>
                                                                {e.value}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <div className='form-group input'>
                                                    <label htmlFor="dobInput">Date</label>
                                                    <DatePicker
                                                        id="Date"
                                                        value={mainPatientModal.Date}
                                                        handleCalendarChangefunc={date => handleCalendarChangeadmission(date, 'Date')}
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <div className='form-group input'>
                                                    <label >Source</label>
                                                    <div className='input'>
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="Source"
                                                            id="Source"
                                                            maxLength={30}
                                                            autoComplete='off'
                                                            value={mainPatientModal.Source}
                                                            onChange={handlePatientChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row row-half'>
                                            <div className="form-group input col-md-12">
                                                <label htmlFor="Description">Notes</label>
                                                <textarea
                                                    className="form-control doc-textarea"
                                                    id="Notes"
                                                    name="Notes"
                                                    value={mainPatientModal.Notes}
                                                    onChange={handlePatientChange}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion defaultExpanded={false}>
                                    <AccordionSummary
                                        className='px-2'
                                        expandIcon={<ExpandMoreIcon />}
                                        id="Pateint1-header"
                                        aria-controls="Pateint1-content"
                                    >
                                        <p className="heading">Patient Insurance</p>
                                    </AccordionSummary>
                                    <AccordionDetails className='px-0 py-1'>
                                        <div className='d-flex gap-10 ps-1 pe-4'>
                                            <div className='input flex-grow-1 col-md-4'>
                                                <label className='mb-1' >Insurance Name</label>
                                                <SuperSearchList
                                                    // type="client"
                                                    // id='InsuranceID'
                                                    // name='InsuranceID'
                                                    // searchValue={mainPatientModal.InsuranceID}
                                                    // data={DropDowns.Location}
                                                    // onChange={handleChangeDD}
                                                    // getSelectedData={handleSelectedData}
                                                    // is={is}
                                                    // sup_btn='sup_btn-Inp'
                                                    // sup_inp='superSearchVisitInp'
                                                    type='server'
                                                    id='InsuranceID'
                                                    name='InsuranceID'
                                                    searchValue={mainPatientModal.InsuranceID}
                                                    ApiLink={API_URL_GENERAL + "/InstantSearch"}
                                                    method='post'
                                                    postBody={insuranceBody}
                                                    onChange={handleChangeDD}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                    icon={true}
                                                    InsuranceInst={true}
                                                    placeholder={"Search..."}
                                                />
                                            </div>
                                            <div className='input flex-grow-1 col-md-4'>
                                                <label className='mb-1' >Subscriber ID</label>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    name="SubscriberID"
                                                    id="SubscriberID"
                                                    value={mainPatientModal.SubscriberID}
                                                    onChange={handlePatientChange}
                                                />
                                            </div>

                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </> :
                            <Accordion defaultExpanded={false}>
                                <AccordionSummary
                                    className='px-2'
                                    expandIcon={<ExpandMoreIcon />}
                                    id="Pateint1-header"
                                    aria-controls="Pateint1-content"
                                >
                                    <p className="heading">Assigned Profiles</p>
                                </AccordionSummary>
                                <AccordionDetails className='px-0 py-1'>
                                    <div className='d-flex gap-10 ps-1 pe-4'>
                                        <div className={PatientValidationModal.LocationIdVal ? 'input flex-grow-1 col-md-4 error' : 'input flex-grow-1 col-md-4'}>
                                            <label className='mb-1' >Location  <span className='req'>*</span></label>
                                            <SuperSearchList
                                                type="client"
                                                id='LocationID'
                                                name='LocationID'
                                                searchValue={mainPatientModal.LocationID}
                                                data={DropDowns.Location}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                                inputError={PatientValidationModal.LocationIdVal}
                                            />
                                            {PatientValidationModal.LocationIdVal}
                                        </div>
                                        <div className={PatientValidationModal.ProviderIdVal ? 'input flex-grow-1 col-md-4 error' : 'input flex-grow-1 col-md-4'}>
                                            <label className='mb-1' >Provider  <span className='req'>*</span></label>
                                            <SuperSearchList
                                                type="client"
                                                id='ProviderID'
                                                name='ProviderID'
                                                searchValue={mainPatientModal.ProviderID}
                                                data={DropDowns.Provider}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                                inputError={PatientValidationModal.ProviderIdVal}
                                            />
                                            {PatientValidationModal.ProviderIdVal}

                                        </div>
                                        <div className='input flex-grow-1 col-md-4'>
                                            <label className='mb-1' >Reffering</label>
                                            <SuperSearchList
                                                type="client"
                                                id='RefProviderID'
                                                name='RefProviderID'
                                                searchValue={mainPatientModal.RefProviderID}
                                                data={DropDowns.RefProvider}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        }
                    </div>
                </div>
            </div >
            <div>
                <ModalFooter isSaved={onClose} handleSave={handleSavePatient} IsEditAllowed={IsEditAllowed} />
            </div>

        </Modal >
    )
}

export default AddNewPat